module.exports = __webpack_public_path__ + "img/p9.b034c818.png";